<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('reportingProfiles.title') }}</h2>
      <p class="text-center">
        {{ $t('reportingProfiles.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">

        <card card-body-classes="table-full-width">
          <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <h4 class="card-title">{{ $t('reportingProfiles.table.title') }}</h4>
            <create-reporting-profile v-if="$auth.can({reporting_profile: 'create'}, 'permissions')"></create-reporting-profile>
          </div>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div class="row">
                <div class="col">
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      prefix-icon="el-icon-search"
                      :placeholder="$t('generic.searchInTablePlaceholder')"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>
            </div>

            <el-table :data="queriedData" :empty-text="$t('generic.noData')">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="$t(column.label)"
                :formatter="column.formatter"/>

              <el-table-column :min-width="50" align="right">
                <div slot-scope="props">
                  <router-link
                    :to="{name: 'reporting-profile-view', params: {id: props.row.id}}">
                    <i class="tim-icons icon-double-right"></i>
                  </router-link>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div
  >
</template>
<script>
import {Option, Select, Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import CreateReportingProfile from "src/pages/ReportingProfiles/ReportingProfileDetails/CreateReportingProfile";
import Fuse from 'fuse.js';
import {mapActions, mapState} from "vuex";
import AddUserToReportingProfile from "@/pages/ReportingProfiles/ReportingProfileDetails/AddUserToReportingProfile.vue";

export default {
  name: 'system-accounts',
  components: {
    AddUserToReportingProfile,
    BasePagination,
    BaseAlert,
    CreateReportingProfile,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapState({
      loading: state => state.reporting_profiles.loading,
      error: state => state.reporting_profiles.error,
      profiles: state => state.reporting_profiles.data,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['label'],
      tableColumns: [
        {
          prop: 'label',
          label: 'reportingProfiles.details.label',
          minWidth: 200
        },
        {
          prop: 'contact_name',
          label: 'reportingProfiles.details.contact_name',
          minWidth: 150
        },
        {
          prop: 'contact_surname',
          label: 'reportingProfiles.details.contact_surname',
          minWidth: 200
        },
        {
          prop: 'last_used_at',
          label: 'reportingProfiles.details.last_used_at',
          minWidth: 200,
          formatter: (row, column, cellValue, index) => {
            if (cellValue) {
              return this.$options.filters.time(cellValue)
            }
          },
        },
        {
          prop: 'created_at',
          label: 'generic.created',
          minWidth: 200,
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
        }
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    ...mapActions(['LoadReportingProfiles']),
  },
  mounted() {
    this.LoadReportingProfiles()
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    "profiles"(profiles) {
      this.tableData = profiles
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.1
      });
    }
  }
};
</script>
<style scoped>
</style>
